import { render, staticRenderFns } from "./RecommendationBusinessCard.vue?vue&type=template&id=cc9e5178&"
import script from "./RecommendationBusinessCard.vue?vue&type=script&lang=js&"
export * from "./RecommendationBusinessCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports